import script from "./StatGroup.vue?vue&type=script&setup=true&lang=ts"
export * from "./StatGroup.vue?vue&type=script&setup=true&lang=ts"

import "./StatGroup.vue?vue&type=style&index=0&id=6d46cca6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d46cca6"]])

export default __exports__